import { Avatar, Divider, Paper, Stack, Typography } from '@mui/material';
import { Contact } from './Contact';
import { useDictionary, useImposter, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleAlert, PurpleFax, PurplePhone, PurpleSmsIcon } from 'Images';
import { useNavigate } from 'react-router-dom';

export const Contacts = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.B2C).UserContacts;

  const { authenticatedUser, fakeUser } = useImposter();

  const hyphenToPhoneNumberHandler = (phoneNumber: string | undefined) => {
    if (!phoneNumber) return undefined;
    if (phoneNumber.length <= 3) return phoneNumber;
    return phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3);
  };

  return (
    <Paper
      sx={{
        p: isDesktop ? '24px' : '16px',
        mb: '48px',
        borderRadius: '16px',
        border: '1px solid #B7CCFF',
        bgcolor: '#E7EDFF',
        boxShadow: 'none',
      }}
    >
      <Stack gap='16px'>
        <Contact
          title={dictionary.email}
          image={PurpleSmsIcon}
          info={fakeUser.email || authenticatedUser.email}
        />
        <Contact
          title={dictionary.phone}
          image={PurplePhone}
          info={hyphenToPhoneNumberHandler(
            fakeUser.getFullMainPhone || authenticatedUser.getFullMainPhone
          )}
        />
      </Stack>
      <Divider
        orientation='horizontal'
        sx={{ m: '24px auto', borderColor: '#B7CCFF' }}
      />
      <Stack>
        <Stack direction='row' alignItems='center' gap='8px'>
          <Avatar
            alt=''
            src={PurpleAlert}
            sx={{ width: '24px', height: '24px' }}
          />
          <Typography variant='body3'>{dictionary.wrongInfo}</Typography>
        </Stack>
        <Typography
          variant='body3'
          sx={{
            textAlign: 'left',
            ml: '30px',
            color: '#1552E8',
            ':hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
            },
          }}
          component='a'
          onClick={() => navigate('/requests/update-personal-details/8/18')}
        >
          {dictionary.updateHere}
        </Typography>
      </Stack>
    </Paper>
  );
};
